import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./TestimonialsCarousel.css";

const testimonials = [
  {
    name: "Arbon Gashi",
    img: require("../assets/ChatGPT_Image_May_20__2025__12_45_48_PM-removebg-preview.png"),
    text: "FOX Academy më ka ndihmuar të kthej dëshirat në profesionin tim të preferuar. Për një periudhë të shkurtër kam mësuar pjesët më kryesore të dizajnit dhe pas përfundimit të trajnimit ndërtoja Portfolion. Pa dyshim që e rekomandoj këtë trajnim për këdo që do të zhvillojë karrierën kreative!"
  },
  {
    name: "Era Selmani",
    img: require("../assets/ChatGPT_Image_May_20__2025__12_47_39_PM-removebg-preview.png"),
    text: "Ky kurs më dha një kombinim të shkëlqyer të teorisë dhe praktikës, duke më pajisur me aftësi që tani i përdor në punën time të përditshme. Veçanërisht më pëlqeu fokusi në zgjidhje praktike dhe projekte reale!"
  },
  {
    name: "Valmir Krasniqi",
    img: require("../assets/ChatGPT_Image_May_20__2025__12_45_48_PM-removebg-preview.png"),
    text: "Përmes FOX Academy arrita të përvetësoj aftësi të reja dhe të rritem profesionalisht shumë më shpejt se kudo tjetër. Trajnimi ishte praktik dhe inspirues!"
  },
  {
    name: "Rinor Kelmendi",
    img: require("../assets/ChatGPT_Image_May_20__2025__12_45_48_PM-removebg-preview.png"),
    text: "Stafi ishte gjithmonë i gatshëm të ndihmojë dhe programi i kursit ishte shumë praktik. Jam falënderues për eksperiencën."
  },
  {
    name: "Erza Shala",
    img: require("../assets/ChatGPT_Image_May_20__2025__12_47_39_PM-removebg-preview.png"),
    text: "FOX Academy më dha mundësinë të punoj në projekte reale dhe të rritem profesionalisht. E rekomandoj për këdo që dëshiron karrierë në dizajn!"
  },
  {
    name: "Sajmir Rexha",
    img: require("../assets/ChatGPT_Image_May_20__2025__12_45_48_PM-removebg-preview.png"),
    text: "Metodat e mësimit ishin moderne dhe frymëzuese. U ndjeva pjesë e një komuniteti të vërtetë kreativ!"
  }
];

const containerVariants = {
  show: {
    transition: {
      staggerChildren: 0.18
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 80, rotate: -8, scale: 0.93 },
  show: {
    opacity: 1,
    y: 0,
    rotate: 0,
    scale: 1,
    boxShadow: "0 4px 40px #ff660044, 0 1px 6px #fff7",
    transition: { type: "spring", duration: 0.76, bounce: 0.35 }
  },
  exit: { opacity: 0, y: 60, rotate: 6, scale: 0.96, transition: { duration: 0.22 } }
};

export function TestimonialsCarousel() {
  const [index, setIndex] = useState(0);
  const cardsToShow = 3;
  const showTestimonials = testimonials.slice(index, index + cardsToShow);

  const handlePrev = () => setIndex(prev => (prev - cardsToShow < 0 ? 0 : prev - cardsToShow));
  const handleNext = () => setIndex(prev => (prev + cardsToShow >= testimonials.length ? prev : prev + cardsToShow));

  return (
    <section className="testimonials-section">
      <div className="testimonials-header-row">
        <h2 className="testimonials-title">
          ÇKA PO THONË STUDENTAT <span className="brand-orange">PËR FOX</span>
        </h2>
        <div className="testimonials-nav">
          <button onClick={handlePrev} disabled={index === 0}>
            &#8592;
          </button>
          <button onClick={handleNext} disabled={index + cardsToShow >= testimonials.length}>
            &#8594;
          </button>
        </div>
      </div>
      <motion.div
        className="testimonials-grid"
        variants={containerVariants}
        initial="hidden"
        animate="show"
        key={index}
      >
        <AnimatePresence initial={false} mode="wait">
          {showTestimonials.map((t) => (
            <motion.div
              className="testimonial-card"
              key={t.name}
              variants={cardVariants}
              initial="hidden"
              animate="show"
              exit="exit"
              layout
              whileHover={{
                scale: 1.07,
                rotate: -2,
                boxShadow: "0 8px 48px #fff9, 0 3px 18px #ff660055",
                transition: { duration: 0.22 }
              }}
            >
              <img src={t.img} alt={t.name} className="testimonial-photo" />
              <div className="testimonial-content">
                <div className="testimonial-name">{t.name}</div>
                <div className="testimonial-text">{t.text}</div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
    </section>
  );
}
